import { FC } from 'react';
import { Styled, OrderStepProps } from './';
import { AiOutlineEdit } from 'react-icons/ai';

import { IoCheckmarkCircle } from 'react-icons/io5';

const OrderStep: FC<OrderStepProps> = ({
  title,
  children,
  mode,
  onEdit,
  overflow,
}) => {
  const isVisible = mode === 'create' || mode === 'edit';

  return (
    <Styled.OrderStepContainer>
      <Styled.OrderStepHeader>
        <Styled.Title>
          {mode === 'edit' && (
            <IoCheckmarkCircle
              size="28px"
              style={{ marginRight: '10px', color: 'green' }}
            />
          )}
          {title}
        </Styled.Title>

        {mode === 'edit' && (
          <Styled.IconWrapper>
            <AiOutlineEdit size="24px" onClick={onEdit} />
          </Styled.IconWrapper>
        )}
      </Styled.OrderStepHeader>
      <Styled.OrderStepBody $isVisible={isVisible} $overflow={overflow}>
        <Styled.OrderStepBodyInner>{children}</Styled.OrderStepBodyInner>
      </Styled.OrderStepBody>
    </Styled.OrderStepContainer>
  );
};

export default OrderStep;
